package com.tregz.robbins

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import org.jetbrains.compose.resources.Font
import tregz.robbins.generated.resources.Res
import tregz.robbins.generated.resources.geist_bold
import tregz.robbins.generated.resources.geist_light
import tregz.robbins.generated.resources.geist_medium
import tregz.robbins.generated.resources.geist_regular
import tregz.robbins.generated.resources.geist_semibold
import tregz.robbins.generated.resources.geist_mono_medium
import tregz.robbins.generated.resources.geist_mono_regular
import tregz.robbins.generated.resources.instrument_serif_italic
import tregz.robbins.generated.resources.instrument_serif_regular

val GeistFamily: FontFamily
    @Composable get() = FontFamily(
        Font(Res.font.geist_light,    FontWeight.Light),
        Font(Res.font.geist_regular,  FontWeight.Normal),
        Font(Res.font.geist_medium,   FontWeight.Medium),
        Font(Res.font.geist_semibold, FontWeight.SemiBold),
        Font(Res.font.geist_bold,     FontWeight.Bold),
    )

val GeistMonoFamily: FontFamily
    @Composable get() = FontFamily(
        Font(Res.font.geist_mono_regular, FontWeight.Normal),
        Font(Res.font.geist_mono_medium,  FontWeight.Medium),
    )

val InstrumentSerifFamily: FontFamily
    @Composable get() = FontFamily(
        Font(Res.font.instrument_serif_regular, FontWeight.Normal, FontStyle.Normal),
        Font(Res.font.instrument_serif_italic,  FontWeight.Normal, FontStyle.Italic),
    )
